import { createFileRoute } from '@tanstack/react-router';


export const Route = createFileRoute('/app/inventory_/labels')({
  // #279 printable QR shelf tags. The search params mirror the inventory list's
  // filter set and are forwarded straight to `parts_queryset` server-side, so the
  // printed sheet is exactly the view the seller came from. This whitelist is the
  // only thing that reaches the endpoint.
  validateSearch: (search) => ({
    status: typeof search.status === 'string' ? search.status : undefined,
    q: typeof search.q === 'string' ? search.q : undefined,
    part_type: typeof search.part_type === 'string' ? search.part_type : undefined,
    disposition: typeof search.disposition === 'string' ? search.disposition : undefined,
    make: typeof search.make === 'string' ? search.make : undefined,
    model: typeof search.model === 'string' ? search.model : undefined,
    year: typeof search.year === 'string' ? search.year : undefined,
    location: typeof search.location === 'string' ? search.location : undefined,
  }),
});
